// extracted by mini-css-extract-plugin
export var DropdownMenu = "OktaHeader-module--DropdownMenu--4e502";
export var accountMenu = "OktaHeader-module--accountMenu--d49a4";
export var buttonWrapper = "OktaHeader-module--buttonWrapper--55c0e";
export var darkLink = "OktaHeader-module--darkLink--f6724";
export var destinationsCategory = "OktaHeader-module--destinationsCategory--d1271";
export var divider = "OktaHeader-module--divider--984f9";
export var greeting = "OktaHeader-module--greeting--daa18";
export var headerMenuContainer = "OktaHeader-module--headerMenuContainer--28b6c";
export var headerMenuContainerHeader = "OktaHeader-module--headerMenuContainerHeader--d5d4a";
export var heading = "OktaHeader-module--heading--0ebea";
export var hidden = "OktaHeader-module--hidden--be1b5";
export var icon = "OktaHeader-module--icon--514ad";
export var listItem = "OktaHeader-module--listItem--0e18a";
export var loggedIn = "OktaHeader-module--loggedIn--3635b";
export var loggedOut = "OktaHeader-module--loggedOut--7e206";
export var logout = "OktaHeader-module--logout--4523f";
export var menuAccountProfile = "OktaHeader-module--menuAccountProfile--27ccd";
export var menuDisplaySideMenu = "OktaHeader-module--menuDisplaySideMenu--7ac55";
export var menuItem = "OktaHeader-module--menuItem--5cbb7";
export var menuItems = "OktaHeader-module--menuItems--188f4";
export var modalClose = "OktaHeader-module--modalClose--aba4b";
export var modalContainer = "OktaHeader-module--modalContainer--a472f";
export var modalContent = "OktaHeader-module--modalContent--47887";
export var modalOverlay = "OktaHeader-module--modalOverlay--47709";
export var myAccount = "OktaHeader-module--myAccount--a2ff3";
export var myBooking = "OktaHeader-module--myBooking--72881";
export var myTrips = "OktaHeader-module--myTrips--67bb7";
export var profileText = "OktaHeader-module--profileText--bba07";
export var sideMenu = "OktaHeader-module--sideMenu--d16ec";
export var signin = "OktaHeader-module--signin--717db";
export var ssoTriggerContainer = "OktaHeader-module--ssoTriggerContainer--36cc6";
export var tail = "OktaHeader-module--tail--44905";
export var textIndent = "OktaHeader-module--textIndent--97616";
export var triggerDDMenu = "OktaHeader-module--triggerDDMenu--7ec6c";
export var triggerSideMenu = "OktaHeader-module--triggerSideMenu--b1358";
export var userName = "OktaHeader-module--userName--bbf40";
export var widgetButtons = "OktaHeader-module--widgetButtons--a3908";